import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ToggleColor, ToggleSize } from './toggle.types';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule],
  selector: 'fl-toggle',
  template: `
    <label
      class="ToggleLabel"
      for="{{ toggleId }}"
      [attr.aria-label]="label"
      [attr.data-size]="size"
      [attr.data-color]="color"
      [attr.disabled]="control.disabled || busy ? true : null"
    >
      <span
        class="ToggleInner"
        [class.NoMargin]="forListItem"
      >
        <input
          #input
          class="NativeElement"
          type="checkbox"
          id="{{ toggleId }}"
          name="{{ toggleId }}"
          role="switch"
          [checked]="control.value"
          [formControl]="control"
          [attr.aria-checked]="control.value || false"
          [attr.disabled]="control.disabled || busy ? true : null"
          [attr.aria-invalid]="control.invalid"
          (click)="onClick($event)"
        />
        <span class="ToggleBackground"></span>
        <span class="ToggleHandle"></span>
      </span>
    </label>
  `,
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleComponent implements OnInit {
  toggleId: string;

  @Input() control: FormControl<boolean>;
  @Input() size = ToggleSize.SMALL;
  @Input() sizeTablet?: ToggleSize;
  @Input() sizeDesktop?: ToggleSize;
  @Input() color = ToggleColor.DARK;
  @Input() forListItem = false;
  @Input() busy = false;
  /** Set aria label for accessibility */
  @Input() label?: string;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.toggleId = generateRandomString();
  }

  onClick(event: Event): void {
    event.stopPropagation();
  }
}

function generateRandomString(): string {
  let text = '';
  const alphabet = 'abcdefghijklmnopqrstuvwxyz';
  for (let i = 0; i < 15; i++) {
    text += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
  }
  return text;
}
